import React from "react";
import SearchInput from "./SearchInput";
import SortBtn from "./SortBtn";
import AddIcon from "../images/add-circle.svg";
import { Button } from "@mui/material";

export default function PrimaryHeader({
  title,
  searchText,
  setSearchText,
  btnTitle,
  searchPlaceHolder,
  tabData,
  activeTab,
  setActiveTab,
  setShowModal,
  setSort,
  sort,
  onChange,
  pagePermission,
}) {
  return (
    <>
      <div className="flex px-4 py-3 md:px-6 md:py-4 bg-white justify-between items-center px-[24px] max-[700px]:flex-col max-[700px]:items-start">
        <div className="font-[700] text-[20px] max-[700px]:mb-[15px]">
          {title}
        </div>
        <div className="flex items-center max-[700px]:w-full max-[700px]:justify-between">
          <div className="relative w-[250px] max-w-[100%] max-[700px]:w-[100%]">
            <div className="absolute h-[100%] top-[0] left-[0] flex items-center max-[768px]:left-[10px] max-[768px]:top-[-2px]">
              <img src="/images/search.svg" alt="search" className="pt-[3px]" />
            </div>
            <input
              type="search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={searchPlaceHolder || "Search..."}
              className="pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[700px]:w-[calc(100%-20px)]"
            />
          </div>
          {pagePermission !== undefined && pagePermission !== null ? (
            pagePermission?.create_permission == 1 && (
              <Button
                type="button"
                className="sav_btn bonus_btn"
                onClick={() => setShowModal(true)}
              >
                <img
                  src="/images/add-circle-wh.svg"
                  alt="add"
                  className="hidden max-[700px]:block"
                />
                <span className="max-[700px]:hidden">{btnTitle}</span>
              </Button>
            )
          ) : (
            <Button
              type="button"
              className="sav_btn bonus_btn"
              onClick={() => setShowModal(true)}
            >
              <img
                src="/images/add-circle-wh.svg"
                alt="add"
                className="hidden max-[700px]:block"
              />
              <span className="max-[700px]:hidden">{btnTitle}</span>
            </Button>
          )}
        </div>
      </div>
      <div className="w-full  bg-white border-b-[1px] border-b-[1px solid #e3e3e3] flex justify-between px-4 md:px-6 relative ">
        <div className="flex justify-start w-full overflow-scroll horizontal-scroll tab-header-bar">
          {tabData.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  setActiveTab({
                    parameter: item.parameter,
                    value: item.value,
                    index: index,
                  });
                  if (onChange !== undefined) {
                    onChange({
                      parameter: item.parameter,
                      value: item.value,
                      index: index,
                    });
                  }
                }}
                className={` after:block py-[6px] px-2 md:py-2 md:px-3 relative cursor-pointer ${
                  activeTab.parameter === item.parameter &&
                  activeTab.value === item.value
                    ? "after:w-full after:bg-[#0560FB] after:h-[3px] after:bottom-0 after:left-0 after:absolute group active"
                    : ""
                }`}
              >
                <p className="whitespace-nowrap text-[12px] md:text-[13px] font-medium md:font-semibold text-gray-500 capitalize tracking-[0] md:tracking-[-.35px] group-[.active]:text-[#0560FB]">
                  {item.label}
                  {item.count ? ` (${item.count})` : ` (0)`}
                </p>
              </div>
            );
          })}
        </div>
        <div className="items-center flex relative">
          <SortBtn sort={sort} setSort={setSort} />
        </div>
      </div>
    </>
  );
}
